import * as React from 'react';
import { Button, Input, useDeviceType } from '@cian/ui-kit';

import * as style from './SearchInput.css';

export interface ISearchInputProps {
  onChange: (value: string) => void;
  onSubmit: () => void;
  value: string;
}

export const SearchInput: React.FC<ISearchInputProps> = props => {
  const { onChange, onSubmit, value } = props;
  const deviceType = useDeviceType();
  const buttonSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);
  const width = React.useMemo(() => (deviceType === 'phone' ? '100%' : 'auto'), [deviceType]);

  const handleChange = React.useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onChange(value);
    },
    [onChange],
  );

  const handleKeyPress = React.useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onSubmit();
      }
    },
    [onSubmit],
  );

  return (
    <div className={style['container']}>
      <Input
        width={width}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder={'Имя или номер ID'}
        value={value}
      />
      <Button onClick={onSubmit} size={buttonSize} theme="fill_primary">
        Найти
      </Button>
    </div>
  );
};
